import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import s from './PromptBlock.module.css';
import { useSelector } from 'react-redux';
import { selectCurrentProject } from '../../../../store/selectors/projectSelectors';
import Button from '../../../../shared/ui/button/Button';
import IconSpark from '../../../../shared/ui/icons/IconSpark';
import { setCurrentProject } from '../../../../store/slices/projectSlice';
import { useAppDispatch } from '../../../../store/store';
import { useDebounce } from '../../../../shared/hooks/useDebounce';
import { generateContent, updateProject } from '../../../../shared/api/textProjectApi';
import { toast } from 'react-toastify';
const EditBlock = () => {
    const dispatch = useAppDispatch();
    const currentProject = useSelector(selectCurrentProject);

    const [prompt, setPrompt] = useState<string>(currentProject?.prompt || '');
    const [lastGeneratedPrompt, setLastGeneratedPrompt] = useState<string>(
        currentProject?.prompt || '',
    );

    const debouncedPrompt = useDebounce(prompt, 500);

    const changePrompt = (e: ChangeEvent<HTMLTextAreaElement>): void => {
        setPrompt(e.target.value);
    };

    useEffect(() => {
        if (currentProject && debouncedPrompt) {
            const newData = { ...currentProject, prompt: prompt };
            dispatch(setCurrentProject(newData));
        }
    }, [debouncedPrompt]);

    const handleGenerateScript = async () => {
        if (currentProject?.id) {
            try {
                const newData = { ...currentProject, prompt: prompt };
                await dispatch(updateProject(newData));
                const response = await dispatch(
                    generateContent({ projectId: currentProject.id, kind: 'text_only' }),
                ).unwrap();
                console.log('Script generated successfully:', response);
                setLastGeneratedPrompt(prompt);
            } catch (error: any) {
                toast.error(error?.message || 'Failed to handle generate script');
                console.error('Failed to handle generate script:', error);
            }
        }
    };

    return (
        <div className={s.block_container}>
            <h3 className={s.bold_header}>Re-create with a new prompt</h3>
            <textarea
                className={s.input}
                style={{ minHeight: '150px' }}
                onChange={changePrompt}
                value={prompt}
            />

            {lastGeneratedPrompt !== prompt && (
                <Button
                    onClick={handleGenerateScript}
                    style={{
                        backgroundColor: '#FFDD35',
                        borderRadius: 5,
                        boxShadow: '1.182px 1.182px 2.363px 0px rgba(0, 0, 0, 0.25)',
                        width: '70%',
                        margin: '30px auto 0 auto',
                    }}
                    icon={<IconSpark color={'black'} />}
                    iconPosition={'left'}
                    text={'Generate again'}
                />
            )}
        </div>
    );
};

export default EditBlock;
